import classNames from "classnames";
import React from "react";

interface PageContainerProps {
  children: React.ReactNode;
  extraWide?: boolean;
  title?: string;
  subtitle?: string;
  headerActions?: React.ReactNode;
}

const Header = ({
  title,
  subtitle,
  headerActions,
}: {
  title?: string;
  subtitle?: string;
  headerActions?: React.ReactNode;
}) => {
  const hasTitleArea = title || subtitle;

  return (
    <div className="w-full flex flex-row items-center justify-between gap-4 py-6 sm:px-8 px-2 md:border-b border-antd-colorBorder">
      {hasTitleArea && (
        <div
          className={classNames("flex items-center min-w-0", {
            "header__left--themes": title === "Themes",
          })}
        >
          <div className="flex flex-col min-w-0">
            {title && (
              <h1 className="text-lg font-semibold truncate">{title}</h1>
            )}
            {subtitle && (
              <span className="text-antd-colorTextSecondary text-sm truncate">
                {subtitle}
              </span>
            )}
          </div>
        </div>
      )}

      {headerActions && (
        <div
          className={classNames("flex items-center gap-2 flex-shrink-0", {
            "ml-auto": !hasTitleArea,
          })}
        >
          {headerActions}
        </div>
      )}
    </div>
  );
};

const PageContainer: React.FC<PageContainerProps> = ({
  title,
  subtitle,
  headerActions,
  children,
  extraWide = false,
}) => {
  return (
    <>
      <Header title={title} subtitle={subtitle} headerActions={headerActions} />
      <div
        className={classNames(
          "max-lg:pt-6 max-sm:px-2 px-6 pt-6 pb-12 mx-auto w-full",
          {
            "max-w-screen-lg": !extraWide,
            "max-w-screen-2xl": extraWide,
          }
        )}
      >
        {children}
      </div>
    </>
  );
};

export default PageContainer;
